// extracted by mini-css-extract-plugin
export var grid = "_s-0";
export var span1 = "_s-2";
export var span10 = "_s-b";
export var span10L = "_s-z";
export var span10M = "_s-n";
export var span10Xl = "_s-1b";
export var span11 = "_s-c";
export var span11L = "_s-10";
export var span11M = "_s-o";
export var span11Xl = "_s-1c";
export var span12 = "_s-d";
export var span12L = "_s-11";
export var span12M = "_s-p";
export var span12Xl = "_s-1d";
export var span1L = "_s-q";
export var span1M = "_s-e";
export var span1Xl = "_s-12";
export var span2 = "_s-3";
export var span2L = "_s-r";
export var span2M = "_s-f";
export var span2Xl = "_s-13";
export var span3 = "_s-4";
export var span3L = "_s-s";
export var span3M = "_s-g";
export var span3Xl = "_s-14";
export var span4 = "_s-5";
export var span4L = "_s-t";
export var span4M = "_s-h";
export var span4Xl = "_s-15";
export var span5 = "_s-6";
export var span5L = "_s-u";
export var span5M = "_s-i";
export var span5Xl = "_s-16";
export var span6 = "_s-7";
export var span6L = "_s-v";
export var span6M = "_s-j";
export var span6Xl = "_s-17";
export var span7 = "_s-8";
export var span7L = "_s-w";
export var span7M = "_s-k";
export var span7Xl = "_s-18";
export var span8 = "_s-9";
export var span8L = "_s-x";
export var span8M = "_s-l";
export var span8Xl = "_s-19";
export var span9 = "_s-a";
export var span9L = "_s-y";
export var span9M = "_s-m";
export var span9Xl = "_s-1a";
export var stretch = "_s-1";